'use client'

export default () => {

    return <>
        <main className="main-container min-h-screen relative flex items-center justify-center py-24 px-4 bg-[#E0F2FE]">
            <div className="w-full max-w-4xl bg-white/90 backdrop-blur-lg rounded-2xl shadow-2xl p-8 md:p-12 text-center transform transition-all duration-500">
                <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">Contact Us</h1>
                <p className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto">
                    Welcome to use FBE Cross-border E-commerce Platform (<a href="https://www.fbehk.com" className="text-blue-600 hover:underline">https://www.fbehk.com</a>). If you have any questions or suggestions about FBE Cross-border E-commerce Platform, please feel free to contact us through the following ways:
                </p>

                <div className="space-y-6 text-left border-t border-gray-200 py-8">
                    <div className="md:flex md:items-center">
                        <h3 className="font-bold text-gray-800 w-full md:w-1/4 mb-2 md:mb-0">Company</h3>
                        <div className="w-full md:w-3/4">
                              <p className="text-gray-700 text-lg">ETRON GROUP LIMITED</p>
                        </div>
                    </div>
                    <div className="md:flex md:items-center">
                        <h3 className="font-bold text-gray-800 w-full md:w-1/4 mb-2 md:mb-0">Customer Service Email</h3>
                        <div className="w-full md:w-3/4">
                            <a href="mailto:fbe@fbehk.com" className="text-blue-600 hover:underline text-lg">fbe@fbehk.com</a>
                        </div>
                    </div>
                    <div className="md:flex md:items-start">
                        <h3 className="font-bold text-gray-800 w-full md:w-1/4 mb-2 md:mb-0">Contact Address</h3>
                        <div className="w-full md:w-3/4">
                            <p className="text-gray-700 text-lg">RM 1603, I6/F, TUNG NING BUILDING, NO.125-126 CONALGHI RD CENIRAL. SHEUNG NAN HONG KONG</p>
                        </div>
                    </div>
                </div>

                <div className="my-8 rounded-xl overflow-hidden shadow-lg border border-gray-200">
                    <iframe
                        width="100%"
                        height="400"
                        src="https://www.openstreetmap.org/export/embed.html?bbox=114.14842665195467%2C22.28529673206326%2C114.15514558553697%2C22.288379176830407&layer=mapnik&marker=22.286838,%20114.152256">

                    </iframe>
                </div>

                <p className="text-gray-600 mb-4 pt-8 border-t border-gray-200">
                    Thank you again for choosing and using FBE cross-border e-commerce platform, we will continue to work hard to provide you with better services!
                </p>
                <p className="font-semibold text-gray-800 mt-6">
                    FBE cross-border e-commerce platform
                </p>
            </div>
        </main></>
}